export default [
  {
    label: 'メールアドレス ',
    key: 'fist_email',
    _style: 'min-width:200px',
  },
  { label: 'ユーザ名', key: 'first_account_name', _style: 'min-width:250px' },
  {
    label: '友達メールアドレス',
    key: 'second_email',
    _style: 'min-width:120px',
  },
  {
    label: '友達ニックネーム',
    key: 'second_account_name',
    _style: 'min-width:200px',
  },
  { label: '連携日時 ', key: 'created_at', _style: 'min-width:90px' },
]
